// Supplies category color tokens and CSS-variable values for the Store Action presentation layer.
import { CSSProperties } from 'react';

export const STORE_ACTION_THEME_TOKENS = {
  verification: '--store-action-verification-placeholder',
  inventory: '--store-action-inventory-placeholder',
  sales: '--store-action-sales-placeholder',
  customer: '--store-action-customer-placeholder',
  agreement: '--store-action-agreement-placeholder',
  initialPayment: '--store-action-initial-payment-placeholder',
  delivery: '--store-action-delivery-placeholder',
  other: '--store-action-other-placeholder',
} as const;

export type StoreActionThemeToken =
  typeof STORE_ACTION_THEME_TOKENS[keyof typeof STORE_ACTION_THEME_TOKENS];

export const STORE_ACTION_THEME_FALLBACK_COLORS: Readonly<
  Record<StoreActionThemeToken, string>
> = {
  [STORE_ACTION_THEME_TOKENS.verification]: '#A3261A',
  [STORE_ACTION_THEME_TOKENS.inventory]: '#8A4B08',
  [STORE_ACTION_THEME_TOKENS.sales]: '#166534',
  [STORE_ACTION_THEME_TOKENS.customer]: '#1D4ED8',
  [STORE_ACTION_THEME_TOKENS.agreement]: '#1E3A8A',
  [STORE_ACTION_THEME_TOKENS.initialPayment]: '#6B21A8',
  [STORE_ACTION_THEME_TOKENS.delivery]: '#155E75',
  [STORE_ACTION_THEME_TOKENS.other]: '#595959',
};

export const OTHER_STORE_ACTION_THEME_TOKEN = STORE_ACTION_THEME_TOKENS.other;

type StoreActionThemeCssVariables = CSSProperties &
  Record<StoreActionThemeToken, string>;

export const STORE_ACTION_THEME_CSS_VARIABLES: StoreActionThemeCssVariables = {
  [STORE_ACTION_THEME_TOKENS.verification]:
    STORE_ACTION_THEME_FALLBACK_COLORS[STORE_ACTION_THEME_TOKENS.verification],
  [STORE_ACTION_THEME_TOKENS.inventory]:
    STORE_ACTION_THEME_FALLBACK_COLORS[STORE_ACTION_THEME_TOKENS.inventory],
  [STORE_ACTION_THEME_TOKENS.sales]:
    STORE_ACTION_THEME_FALLBACK_COLORS[STORE_ACTION_THEME_TOKENS.sales],
  [STORE_ACTION_THEME_TOKENS.customer]:
    STORE_ACTION_THEME_FALLBACK_COLORS[STORE_ACTION_THEME_TOKENS.customer],
  [STORE_ACTION_THEME_TOKENS.agreement]:
    STORE_ACTION_THEME_FALLBACK_COLORS[STORE_ACTION_THEME_TOKENS.agreement],
  [STORE_ACTION_THEME_TOKENS.initialPayment]:
    STORE_ACTION_THEME_FALLBACK_COLORS[
      STORE_ACTION_THEME_TOKENS.initialPayment
    ],
  [STORE_ACTION_THEME_TOKENS.delivery]:
    STORE_ACTION_THEME_FALLBACK_COLORS[STORE_ACTION_THEME_TOKENS.delivery],
  [STORE_ACTION_THEME_TOKENS.other]:
    STORE_ACTION_THEME_FALLBACK_COLORS[STORE_ACTION_THEME_TOKENS.other],
};

export const getStoreActionThemeFallbackColor = (
  token: StoreActionThemeToken
): string => STORE_ACTION_THEME_FALLBACK_COLORS[token];
